import CurrencyPaneEditorValue from "./CurrencyPaneEditorValue";

export default CurrencyPaneEditorValue;
export { CurrencyPaneEditorValue };
